interface TrashIconProps {
  className?: string;
}

export const TrashIcon = ({ className }: TrashIconProps) => (
  <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M5.25 5.75L6.1875 20.75C6.23203 21.6167 6.8625 22.25 7.6875 22.25H16.3125C17.1408 22.25 17.7595 21.6167 17.8125 20.75L18.75 5.75"
      stroke="#262626"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.75 5.75H20.25H3.75Z" fill="#262626" />
    <path d="M3.75 5.75H20.25" stroke="#262626" strokeMiterlimit="10" strokeLinecap="round" />
    <path
      d="M9 5.75V3.875C8.99957 3.72715 9.02837 3.58066 9.08475 3.44397C9.14114 3.30729 9.22399 3.1831 9.32854 3.07854C9.43309 2.97399 9.55728 2.89114 9.69397 2.83476C9.83066 2.77838 9.97714 2.74957 10.125 2.75H13.875C14.0229 2.74957 14.1693 2.77838 14.306 2.83476C14.4427 2.89114 14.5669 2.97399 14.6715 3.07854C14.776 3.1831 14.8589 3.30729 14.9152 3.44397C14.9716 3.58066 15.0004 3.72715 15 3.875V5.75M12 8.75001V19.25M8.625 8.75001L9 19.25M15.375 8.75001L15 19.25"
      stroke="#262626"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);